module.exports = __webpack_public_path__ + "static/media/easymob.272f822a.png";